export { SharedUiDialogModule } from './lib/shared-ui-dialog.module';
export { DialogService } from './lib/dialog.service';
export { Action } from './lib/models/action';
